/* Storefront snapshot only. The order backend verifies the final shipping market. */
(() => {
  if (window.DSSOrderMarketInstalled) return;
  window.DSSOrderMarketInstalled = true;
  const attribute = 'dss_shopify_market_gid';
  const inputName = 'attributes[' + attribute + ']';
  const validGID = /^gid:\/\/shopify\/Market\/[1-9][0-9]{0,19}$/;
  let submitting = false;
  function context() { return document.querySelector('[data-dss-order-market]'); }
  function cartForm(form, ctx) {
    if (!(form instanceof HTMLFormElement) || !ctx || form.method.toLowerCase() !== 'post') return false;
    const action = new URL(form.action, location.href);
    return action.origin === location.origin && action.pathname === ctx.dataset.cartUrl;
  }
  function showError(target, message) {
    const container = target.closest('form') || target.parentElement;
    let node = container.querySelector('[data-dss-order-market-error]');
    if (!node) { node = document.createElement('p'); node.dataset.dssOrderMarketError = ''; node.setAttribute('role','alert'); container.append(node); }
    node.textContent = message;
  }
  function buyerValid(form) {
    const profile = form.querySelector('dss-buyer-profile');
    const type = profile?.querySelector('select'), name = profile?.querySelector('[data-buyer-name]');
    if (!type || !name || !['individual','company'].includes(type.value)) { type?.focus(); return false; }
    name.value = name.value.trim();
    if (type.value === 'company' && !name.value) { name.focus(); return false; }
    return form.elements.namedItem('attributes[dss_buyer_profile_source]')?.value === 'checkout_v1' && form.reportValidity();
  }
  function setInput(form, gid) {
    [...form.elements].filter(el => el.name === inputName).forEach(el => el.remove());
    const input = document.createElement('input'); input.type = 'hidden'; input.name = inputName; input.value = gid; form.append(input);
  }
  document.addEventListener('submit', event => {
    const ctx = context(), form = event.target;
    if (!ctx && form instanceof HTMLFormElement && form.id === 'cart-form' && (!event.submitter || event.submitter.name === 'checkout')) {
      event.preventDefault(); event.stopImmediatePropagation(); showError(form,window.FivePointI18n.t("Shopping region unavailable. Refresh this page.")); return;
    }
    if (!cartForm(form,ctx)) return;
    const checkout = !event.submitter || event.submitter.name === 'checkout';
    const regionValid = validGID.test(ctx.dataset.marketGid || '');
    if (checkout) {
      const updating = document.querySelector('fivepoint-cart-component[aria-busy="true"], cart-items-component[aria-busy="true"], cart-items-component.cart-items-disabled');
      if (!regionValid || submitting || updating || !buyerValid(form)) {
        event.preventDefault(); event.stopImmediatePropagation();
        showError(form, !regionValid ? ctx.dataset.error : ctx.dataset.profileError); return;
      }
      // Keep the submitter enabled: name=checkout must be in the native POST.
      submitting = true;
      event.submitter?.setAttribute('aria-busy','true');
    }
    if (regionValid) setInput(form,ctx.dataset.marketGid);
  }, true);
  document.addEventListener('formdata', event => {
    const ctx = context();
    if (cartForm(event.target,ctx) && validGID.test(ctx.dataset.marketGid || '')) event.formData.set(inputName,ctx.dataset.marketGid);
  }, true);
  window.addEventListener('pageshow', () => { submitting = false; document.querySelectorAll('[name="checkout"][aria-busy]').forEach(el=>el.removeAttribute('aria-busy')); });

  // Rewrite href too: keyboard/new-tab actions must reach the same buyer form.
  function prepare(link) {
    if (!(link instanceof HTMLAnchorElement) || !link.isConnected || !link.hasAttribute('href')) return;
    const ctx = context();
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/i.test(url.pathname)) return;
    link.dataset.dssCheckoutLink = '';
    const cart = ctx?.dataset.cartUrl;
    if (cart?.startsWith('/') && !cart.startsWith('//')) link.href = cart + '#dss-buyer-profile';
    else { link.href = '#'; link.setAttribute('aria-disabled','true'); }
  }
  function scan(root) { if (!root.isConnected) return; if (root instanceof Element) prepare(root); root.querySelectorAll?.('a[href]').forEach(prepare); }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') prepare(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
  for (const kind of ['pointerdown','keydown','contextmenu','auxclick']) {
    document.addEventListener(kind,event => prepare(event.target.closest?.('a[href]')),true);
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    prepare(link);
    if (!link.hasAttribute('data-dss-checkout-link') || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const ctx = context();
    if (!ctx || !validGID.test(ctx.dataset.marketGid || '')) { showError(link,ctx?.dataset.error || window.FivePointI18n.t("Shopping region unavailable.")); return; }
    let profile = document.querySelector('#cart-form dss-buyer-profile');
    const bag = document.getElementById('cart-drawer');
    if (bag) {
      await bag.refreshAndOpen();
      profile = bag.querySelector('dss-buyer-profile');
    }
    if (profile) { profile.scrollIntoView({block:'center'}); profile.querySelector('select')?.focus(); }
    else location.assign(link.href);
  }, true);
})();

